import React, { useRef, useState } from "react";
import * as IoIcons from "react-icons/io";
import "../estilos.css";
import { Row, Label } from "reactstrap";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import QRGenerator from "../codereader/Qrgenerator";
import { useReactToPrint } from "react-to-print";

function EtiquetaNP({
  indice,
  inputList,
  mRecibas,
  tipo,
  bColor,
  btitle,
  llamada,
  orientacion,
}) {
  const [indexImp, setIndexImp] = useState(0);
  const cantidadAlmacen = tipo === "parcial" ? true : false;
  const componentRef = React.useMemo(
    () =>
      Array(500)
        .fill(0)
        .map((i) => React.createRef()),
    []
  );
  const handlePrint = useReactToPrint({
    content: () => componentRef[indexImp].current,
  });
  const componentRefTEV = useRef();
  const handlePrintTEV = useReactToPrint({
    content: () => componentRefTEV.current,
  });
  return (
    <>
      <button
        class={"btn-" + bColor + " cbutton"}
        title={btitle}
        //style={{ display: "none" }}
        onMouseDown={() => setIndexImp(indice)}
        onClick={() =>
          tipo === "todo" ? handlePrintTEV() : handlePrint(indice)
        }
      >
        <IoIcons.IoIosPrint /> {tipo === "todo" ? "Imprimir NP" : ""}
      </button>

      <div style={{ display: "none" }}>
        <div ref={componentRefTEV}>
          {inputList.map((x, i) => {
            return (
              x.activo && (
                <div ref={componentRef[i]} id="rd1">                  
                      <>
                        <div className="page-breaksmtop">
                          <Row>
                            <div class="col-lg-12 col-md-12 col-sm-12  textaligmentcenter">
                              <img
                                className="imgmaretiqueta"
                                alt="logo"
                                src="assets/img/Logo/logon.png"
                              />
                            </div>
                            <div class="col-lg-12 col-md-12 col-sm-12 textaligmentcenter ">
                              <h1 class=" textaligmentcenter fontblackbold ">
                                BOON TEC INTERNATIONAL, S. de R.L. de C.V.
                              </h1>
                            </div>
                            <div class="col-lg-12 col-md-12 col-sm-12 margintop-16px textaligmentcenter">
                              <h3 class="  textaligmentcenter  fontblackbold ">
                                Norte 2 #14, Fracc. Cd. Industrial.H. Matamoros,
                                Mexico CP 87499
                              </h3>
                            </div>
                          </Row>
                          <div>
                            <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2">
                              <Table className="bordersubtabla">
                                <Thead>
                                  <Tr>
                                    <Th></Th>
                                    <Th></Th>
                                  </Tr>
                                </Thead>
                                <Tbody>                                  
                                  <Tr>
                                    <Td className="fontsize50px textaligmentcenter">
                                      <Label className="fontblackbold">
                                        PART NO:
                                      </Label>
                                    </Td>
                                    <Td className="fontsize50px textaligmentcenter">
                                      <p className="floatleft fontblackbold subrayado ">
                                        {x.numerodeParte}
                                      </p>{" "}
                                    </Td>
                                  </Tr>
                                  <Tr>
                                    <Td className="fontsize50px textaligmentcenter">
                                      <Label className="  fontblackbold">
                                        DESCRIPTION:
                                      </Label>
                                    </Td>
                                    <Td className="fontsize50px textaligmentcenter">
                                      <p className="floatleft  fontblackbold">
                                        {x.descripcion}
                                      </p>
                                    </Td>
                                  </Tr>
                                  <Tr>
                                    <Td className="fontsize50px textaligmentcenter">
                                      <Label className="fontblackbold">
                                        MFG DATE:
                                      </Label>
                                    </Td>
                                    <Td className="fontsize50px textaligmentcenter">
                                      <p className="floatleft fontblackbold">
                                        {mRecibas.fechaDeReciba}
                                      </p>{" "}
                                    </Td>
                                  </Tr>

                                  <Tr>
                                    <Td className="fontsize50px textaligmentcenter">
                                      <Label className="fontblackbold">
                                        QUANTITY:
                                      </Label>
                                    </Td>
                                    <Td className="fontsize50px textaligmentcenter">
                                      <p className="floatleft fontblackbold">
                                        { x.cantidadRecibidaNP}
                                      </p>
                                    </Td>
                                  </Tr>
                                  <Tr>
                                    <Td className="fontsize50px textaligmentcenter">
                                      <Label className="fontblackbold">
                                        RECIBA
                                      </Label>
                                    </Td>
                                    <Td className="fontsize50px textaligmentcenter">
                                      <p className="floatleft fontblackbold">
                                        {x.numero}
                                      </p>
                                    </Td>
                                  </Tr>                                  
                                  <Tr>
                                    <Td className="fontsize50px textaligmentcenter">
                                      <Label className="fontblackbold">
                                        CLIENT:
                                      </Label>
                                    </Td>
                                    <Td className="fontsize50px textaligmentcenter">
                                      <p className="floatleft fontblackbold">
                                        {x.cliente}
                                      </p>
                                    </Td>
                                  </Tr> 
                                  <Tr>
                                    <Td className="fontsize50px textaligmentcenter">
                                      <Label className="fontblackbold">
                                        CONTAINERS:
                                      </Label>
                                    </Td>
                                    <Td className="fontsize50px textaligmentcenter">
                                      <p className="floatleft fontblackbold">
                                        {x.materialEnCantidadNP}
                                      </p>
                                    </Td>
                                  </Tr>  
                                  <Tr>
                                    <Td className="fontsize50px textaligmentcenter">
                                      <Label className="fontblackbold">
                                        QR:
                                      </Label>
                                    </Td>
                                    <Td className="fontsize50px textaligmentcenter">
                                      <p className="floatleft fontblackbold">
                                      {x.krecibaNP}
                                      </p>
                                    </Td>
                                  </Tr>                                  
                                </Tbody>
                              </Table>
                              <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 textaligmentcenter mt-3">
                                <QRGenerator data={x.krecibaNP} />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="efooter">
                          <p className="floatleft margintop-16px mr-3 fontsize40px fontblackbold">
                            Doc ID: FOR-QA66
                          </p>{" "}
                          <br />
                          <p className="floatright margintop-16px mr-3 fontsize40px fontblackbold">
                            Revisión: A
                          </p>{" "}
                          <br />
                        </div>
                      </>                                  
                </div>
              )
            );
          })}
        </div>
      </div >
    </>
  );
}
export default EtiquetaNP;
